import React, { useContext } from "react";
import style from "./index.module.scss";
import { Spin } from "antd";
import HomeworkListItem from "./components/HomeworkListItem";
import useRequest from "utils/useRequest";
import { getWeekTimePaper } from "service/homework";
import { CourseContext } from "../Store";

export default function Homework() {
    const { course } = useContext(CourseContext);
    const [homework, { loading }] = useRequest(
        () => getWeekTimePaper(course.weekTimeId),
        {},
        [course.weekTimeId]
    );

    return (
        <div className={style.root}>
            <Spin spinning={loading}>
                <div className={style.header}>
                    <div className={style.count}>共 1 项作业任务</div>
                </div>

                {homework && <HomeworkListItem data={homework} />}
            </Spin>
        </div>
    );
}
